import React from 'react';
import { useToggle } from 'react-use';
import { SideNavMenu } from 'components';

const withSideNavMenu = (Component) => {
  return (props) => {
    const [isSideMenuOpen, toggleSideMenu] = useToggle(false);
    const allProps = { ...props, toggleSideMenu };

    return (
      <>
        <Component {...allProps} />
        <SideNavMenu open={isSideMenuOpen} onClose={toggleSideMenu} />
      </>
    );
  };
};

export default withSideNavMenu;
